import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import noData from 'highcharts/modules/no-data-to-display';
import moment from 'moment';
import AbstractChart from '../../../../shared-components/chart/AbstractChart';
import { AXIS_POINT_LIMIT } from './ChartConstants';
import { LIST_CHARTS, DATE_TIME_IN_YYYY_MM_DD_FORMAT } from '../../constants/CompareConstants';
import {
  getYAxisTickInterval,
  parseAreaChartData,
  parseLineChartData,
} from '../../../../shared-components/chart/HighChartUtils';
import {
  DEFAULT_HIGH_CHART_MAP_OPTIONS,
  MAP_OPTIONS,
} from '../../../../shared-components/chart/constants/HighchartsConstants';
noData(Highcharts);

class ChartForEachTopic extends AbstractChart {
  constructor(props) {
    super(props);
    this.state = {
      isCommentsActive: null,
      chartData: [],
      source: [],
      topicId: null,
      tickInterval: [],
      mapDataFromProps: {},
      filterDateRange: {
        fromDate: moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
        toDate: moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
      },
      mapOptions: {
        ...JSON.parse(JSON.stringify(DEFAULT_HIGH_CHART_MAP_OPTIONS)),
        chart: {
          type: this.props.chartType,
          backgroundColor: 'white',
          marginBottom: 30,
          marginLeft: 60,
          marginRight: 20,
          marginTop: 45,
          height: 240,
        },
      },
    };

    this.chartComponent = React.createRef();
  }

  componentDidMount() {
    if (this.props.chartId === LIST_CHARTS.sentiment.id) {
      Highcharts.seriesTypes.line.prototype.drawLegendSymbol =
        Highcharts.seriesTypes.column.prototype.drawLegendSymbol;
    }
  }

  parseChartData(chartId, data) {
    if (chartId === LIST_CHARTS.emotion.id) {
      return parseAreaChartData(JSON.parse(JSON.stringify(data)));
    } else {
      return parseLineChartData(JSON.parse(JSON.stringify(data)));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { title, source } = this.props;
    this.setState({ chartData: [] });
    const chartData = this.parseChartData(nextProps.chartId, nextProps.data);
    let { mapOptions } = this.state;
    mapOptions[MAP_OPTIONS.series] = chartData.chart;
    mapOptions[MAP_OPTIONS.title][MAP_OPTIONS.text] = title;
    mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.tickInterval] = getYAxisTickInterval(
      chartData,
      AXIS_POINT_LIMIT,
    );
    mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.max] = Math.max(...chartData.tickInterval);
    this.setState({
      chartData,
      mapOptions,
      source,
    });
  }

  render() {
    const { mapOptions } = this.state;
    return (
      <React.Fragment>
        {mapOptions[MAP_OPTIONS.series] && mapOptions[MAP_OPTIONS.series].length > 0 ? (
          <HighchartsReact
            highcharts={Highcharts}
            options={mapOptions}
            allowChartUpdate={true}
            immutable={false}
            updateArgs={[true, true, true]}
            ref={this.chartComponent}
          />
        ) : (
          <HighchartsReact highcharts={Highcharts} options={mapOptions} ref={this.chartComponent} />
        )}
      </React.Fragment>
    );
  }
}

export default ChartForEachTopic;



// WEBPACK FOOTER //
// ./src/features/home/components/compare/chart/CompareFeatureChartOfEachTopic.js